import Entity from "./entity";

class Activity extends Entity {
  constructor({ id, restaurantId, location, date, type } = {}) {
    super({ id: id, restaurantId: restaurantId });
    this.location = location;
    this.date = date;
    this.type = type;
  }

  _toMap() {
    return {
      location: this.location,
      date: this.date,
      type: this.type
    };
  }

  static _fromMap(snapData) {
    snapData.date = snapData.date
      ? snapData.date.toDate
        ? snapData.date.toDate()
        : snapData.date
      : null;

    return new Activity(snapData);
  }

  /**
   * @returns {string} A `string` representation of the collection to which this
   * `LocationCode` belongs to.
   */
  get _collectionName() {
    return "activities";
  }
}
////

export default Activity;
